<template>
    <div v-if="popupType" @click="close" class="popup-escape" :class="popupStore?.closeable === false ? 'no-escape' : ''"></div>

    <PopupFetch
        v-if="popupType === 'fetch'"
        v-bind="popupProps"
    />
    <PopupConfirm
        v-if="popupType === 'confirm'"
        v-bind="popupProps"
    />
    <PopupNotice
        v-if="popupType === 'notice'"
        v-bind="popupProps"
    />
    <PopupForm
        v-if="popupType === 'form'"
        v-bind="popupProps"
    />
    <PopupCustom
        v-if="popupType === 'custom'"
        v-bind="popupProps"
    />
</template>

<script>
import { usePopupStore } from '@/stores/utils/popup';
import { mapActions } from 'pinia';
import PopupFetch from '@/components/popups/PopupFetch';
import PopupConfirm from '@/components/popups/PopupConfirm';
import PopupNotice from '@/components/popups/PopupNotice';
import PopupForm from '@/components/popups/PopupForm';
import PopupCustom from '@/components/popups/PopupCustom';

export default {
    name: 'PopupContainer',
    components: {
        PopupConfirm,
        PopupNotice,
        PopupForm,
        PopupFetch,
        PopupCustom
    },
    computed: {
        popupStore() {
            return usePopupStore();
        },
        popupType() {
            return this.popupStore.popupType;
        },
        popupProps() {
            return this.popupStore.popupProps;
        }
    },
    methods: {
        ...mapActions(usePopupStore, ['closePopup']),
        close() {
            if(this.popupType === 'confirm' && this.popupProps?.closeable === false) {
                return;
            } else {
                this.closePopup();
            }
        },
        // positionPopup() {
        //     const popup = document.querySelector('[class^="popup-type-"]');
        //     if (!popup) return;
        //     const popupHeight = popup.offsetHeight;
        //     const windowHeight = window.innerHeight;

        //     // popup.style.maxHeight = window.innerHeight;

        //     if (popupHeight > windowHeight) {
        //         popup.style.top = '0';
        //         popup.style.marginTop = '0';
        //     } else {
        //         popup.style.top = '50%';
        //         popup.style.marginTop = `-${popupHeight / 2}px`;
        //     }
        // },
        positionPopup() {
            const popup = document.querySelector('[class^="popup-type-"]');
            if (!popup) return;
            const popupHeight = popup.offsetHeight;
            const windowHeight = window.innerHeight;

            if (popupHeight > windowHeight) {
                popup.style.top = '0';
                popup.style.marginTop = '0';
                popup.style.maxHeight = `${windowHeight}px`;
            } else {
                popup.style.top = '50%';
                popup.style.marginTop = `-${popupHeight / 2}px`;
                popup.style.maxHeight = '';
            }
        },
        lockScroll() {
            this.scrollPosition = window.pageYOffset;
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollPosition}px`;
            document.body.style.width = '100%';
        },
        unlockScroll() {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            window.scrollTo(0, this.scrollPosition);
        }
    },
    watch: {
        $route() {
            this.closePopup();
        },
        popupType(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.positionPopup();
                    this.lockScroll();
                });
                window.addEventListener('resize', this.positionPopup);
            } else {
                this.unlockScroll();
                window.removeEventListener('resize', this.positionPopup);
            }
        },
    },
    mounted() {
        if(this.popupType) {
            this.lockScroll();
            this.positionPopup();
        }
    },
    unmounted() {
        if(this.popupType) {
            this.unlockScroll();
            window.removeEventListener('resize', this.positionPopup);
        }
    }
};
</script>
